import { useEffect, useState } from "react";
import { Card } from "./common";

const FIELDS = [
  ["construction_notes", "Lavorazioni", "Es. cuciture ribattute, fodera integrale, asole a macchina…"],
  ["stitching_details", "Cuciture e finiture", "Punti, margini, rifiniture"],
  ["care_label_notes", "Etichetta composizione e lavaggio", "Es. 100% cotone · lavaggio 30° · non asciugatrice"],
  ["production_notes", "Note per la produzione", "Indicazioni per il laboratorio"],
];

export function ProductionDetailsForm({ detail, canEdit, onSave, busy }) {
  const g = detail.garment;
  const [tp, setTp] = useState({});
  const [flags, setFlags] = useState({});
  useEffect(() => {
    setTp(g.techpack_draft || {});
    setFlags({ measurements_confirmed: !!g.measurements_confirmed, cost_confirmed: !!g.cost_confirmed, cost: g.cost || "", retail_price: g.retail_price || "" });
  }, [g]);
  const save = () => onSave({ techpack_draft: { ...(g.techpack_draft || {}), ...tp },
    measurements_confirmed: flags.measurements_confirmed, cost_confirmed: flags.cost_confirmed,
    cost: Number(flags.cost) || 0, retail_price: Number(flags.retail_price) || 0 });
  const rows = g.size_measurements?.rows?.length || 0;
  return (
    <Card title="Lavorazioni, misure e costi" testId="sampling-details">
      <div className="grid md:grid-cols-2 gap-4" id="sampling-construction">
        {FIELDS.map(([k, label, ph]) => (
          <div key={k}><label className="label-caps block mb-2">{label}</label>
            <textarea disabled={!canEdit} rows={2} className="input-dark" placeholder={ph} value={tp[k] || ""} onChange={e => setTp({ ...tp, [k]: e.target.value })} data-testid={`details-${k}`}/></div>
        ))}
      </div>
      <div className="grid md:grid-cols-3 gap-4 mt-5" id="sampling-pricing">
        <div><label className="label-caps block mb-2">Costo industriale €</label>
          <input disabled={!canEdit} type="number" min="0" step="0.01" className="input-dark" value={flags.cost} onChange={e => setFlags({ ...flags, cost: e.target.value })} data-testid="details-cost"/>
          <div className="text-xs opacity-60 mt-1">Materiali da distinta: € {Number(detail.bom_total || 0).toFixed(2)}</div></div>
        <div><label className="label-caps block mb-2">Prezzo di vendita €</label>
          <input disabled={!canEdit} type="number" min="0" step="0.01" className="input-dark" value={flags.retail_price} onChange={e => setFlags({ ...flags, retail_price: e.target.value })} data-testid="details-price"/></div>
        <div className="space-y-2 pt-6 text-sm">
          <label className="flex items-center gap-2 cursor-pointer"><input disabled={!canEdit} type="checkbox" checked={flags.cost_confirmed} onChange={e => setFlags({ ...flags, cost_confirmed: e.target.checked })} data-testid="details-cost-confirmed"/> Costo confermato</label>
          <label className="flex items-center gap-2 cursor-pointer"><input disabled={!canEdit} type="checkbox" checked={flags.measurements_confirmed} onChange={e => setFlags({ ...flags, measurements_confirmed: e.target.checked })} data-testid="details-measurements-confirmed"/> Misure definitive ({rows} righe)</label>
        </div>
      </div>
      {canEdit && <div className="flex justify-end mt-4"><button disabled={busy} onClick={save} className="btn-gold" data-testid="details-save">{busy ? "Salvataggio…" : "Salva"}</button></div>}
    </Card>
  );
}
